import React, {  } from 'react';
import styles from '../Wyszukiwarka.module.css';


  export default function TechnologiaId({technologiaId, setTechnologiaId} ){


  return(
      <div  className={styles.colData_nr}>

      <label className={styles.labelData}> ID tech </label>
      <input className={styles.inputData} style={{width:"70px"}} type="text"
            value={technologiaId}
            onChange={(event) => {
              const re = /^[0-9]+$/;
              if (event.target.value === '' || re.test(event.target.value)) {
              setTechnologiaId(event.target.value);
              }
            }}></input>
    </div>
  );
}